module.exports = __webpack_public_path__ + "static/icons/icon-snocountry-c8968390159556ef05b1e92813fc2a00.svg";